import { IonFab, IonFabButton, IonFabList, IonIcon, IonLabel } from '@ionic/react';
import { call, helpCircle, mail } from 'ionicons/icons';

import { OdooCompany } from '../types/models';

export const FabContact: React.FC<{ company: OdooCompany }> = ({ company }) => {
    return (
        <IonFab slot="fixed" vertical="bottom" horizontal="end">
            <IonFabButton>
                <IonIcon icon={helpCircle}></IonIcon>
            </IonFabButton>
            <IonFabList side="top">
                <IonFabButton href={company?.phone && `tel:${company.phone}`}>
                    <IonLabel>Appeler le geiq</IonLabel>
                    <IonIcon icon={call}></IonIcon>
                </IonFabButton>
                <IonFabButton href={company?.email && `mailto:${company.email}`}>
                    <IonLabel>Envoyer un mail au geiq</IonLabel>
                    <IonIcon icon={mail}></IonIcon>
                </IonFabButton>
            </IonFabList>
        </IonFab>
    );
};
